import React, { Component } from 'react';

import LocalizedLink from '../../components/LocalizedLink';
import DocumentItem from '../../components/DocumentItem';
import Paginator from '../../components/Paginator';
import TableFilter from '../../components/TableFilter';
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from 'reactstrap';
import { ROUTES } from '../../constants/routes';
import { LINK_LABELS } from '../../constants/labels';
import { TRANSLATIONS } from '../../constants/translations';
import { getLabelFromLang } from '../../utils';
import withTableFilter from '../../HOC/withTableFilter';
import Loader from '../../components/Loader';

const FILTER_SHAPE = {
  search: {
    label: 'Narrow by word',
    placeholder: 'Any',
    type: 'text',
    initialValue: '',
  },
};

class DocumentsPage extends Component {
  componentDidMount() {
    const { lang, getList } = this.props;
    getList({ lang });
  }

  getList = ({ page }) => {
    const { lang, filter, getList } = this.props;
    getList({ lang, page, filter });
  };

  render() {
    const {
      list,
      loading,
      allCount,
      lang,
      filter,
      onFilterChange,
    } = this.props;

    return (
      <>
        {loading && <Loader type="fixed" />}
        <section className="bg-gradient-info py-5">
          <Container>
            <Breadcrumb listClassName="breadcrumb-dark breadcrumb-links pb-2">
              <BreadcrumbItem>
                <LocalizedLink to={ROUTES.HOME}>
                  {getLabelFromLang(LINK_LABELS.HOME, lang)}
                </LocalizedLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <LocalizedLink to={ROUTES.SERVICES}>
                  {getLabelFromLang(LINK_LABELS.SERVICES, lang)}
                </LocalizedLink>
              </BreadcrumbItem>
              <BreadcrumbItem aria-current="page" className="active">
                {getLabelFromLang(LINK_LABELS.DOCUMENTS, lang)}
              </BreadcrumbItem>
            </Breadcrumb>
            <Row className="align-items-stretch">
              <Col lg={4} xs={12}>
                <h1 className="display-2 text-white mb-0">
                  {getLabelFromLang(LINK_LABELS.DOCUMENTS, lang)}
                </h1>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="py-6">
          <Container>
            <TableFilter
              filterValues={filter}
              filterShape={FILTER_SHAPE}
              onChange={onFilterChange}
              onSearch={this.getList}
            />
          </Container>
          <Container className="pt-5 pb-6">
            <Row>
              {!loading && list && !list.length && (
                <div className="h2">
                  {getLabelFromLang(TRANSLATIONS.NO_CONTENT_MSG, lang)}
                </div>
              )}
              {list &&
                list.map(item => (
                  <Col key={`doc-item-${item.id}`} md={6}>
                    <DocumentItem item={item} />
                  </Col>
                ))}
            </Row>
            <Paginator getItems={this.getList} amount={allCount} />
          </Container>
        </section>
      </>
    );
  }
}

export default withTableFilter({
  shape: FILTER_SHAPE,
})(DocumentsPage);
